import { Form } from '@/common/components/Form.tsx'
import Select from 'react-select'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { Input } from '@/common/components/Input.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

const businessCategory = [
  'businessCategory_1',
  'businessCategory_2',
  'businessCategory_3',
  'businessCategory_4',
]
const serviceDeliveryMethod = ['in_person', 'hybrid', 'virtual']
const languagesSupported = ['english', 'spanish', 'other']
const servicesOffered = [
  { value: 'Tuition and Fees', label: 'tuition_and_fees_1' },
  {
    value: 'Technical College: fees and materials',
    label: 'technical_college_fees_and_materials',
  },
  { value: 'Tutoring', label: 'tutoring' },
  { value: 'After School Program', label: 'after_school_program' },
  { value: 'Summer Program', label: 'summer_program' },
  {
    value: 'Instructional Materials and Curricula',
    label: 'instructional_materials_and_curricula',
  },
  {
    value: 'Educational Software and Applications',
    label: 'educational_software_and_applications',
  },
  {
    value: 'Consumable Educational Supplies',
    label: 'consumable_educational_supplies',
  },
  {
    value: 'Technological devices and Computer hardware',
    label: 'technological_devices_and_computer_hardware',
  },
  {
    value: 'Examination or preparation course',
    label: 'examination_or_preparation_course',
  },
  {
    value: 'Service or program provided by LEA',
    label: 'service_or_program_provided_by_lea',
  },
  { value: 'Educational Therapy', label: 'educational_therapy' },
  { value: 'Transportation', label: 'transportation' },
  { value: 'Extracurricular Activities', label: 'extracurricular_activities' },
  { value: 'Other', label: 'other' },
]

export default function BasicBusinessInfo() {
  const { t: translate } = useTranslation()
  const { goNext } = useWizardContext()
  const validateForm = () => {
    goNext()
  }

  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('business_info')}</WizardStepTitle>

        <WizardStepContent>
          <div className="flex-grow mx-auto max-w-xl">
            <h1 className="font-medium text-lg mb-4">
              {translate('basic_info')}
            </h1>
            <Form className="flex flex-col space-y-4">
              <div>
                <label
                  htmlFor="schoolname"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('business_category_organization')}
                  <span className="text-danger ml-1">*</span>
                </label>
                <div className="mt-1">
                  <select
                    id="category"
                    name="category"
                    autoComplete="organization"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                  >
                    {businessCategory.map((category) => (
                      <option key={category} value={category}>
                        {translate(category)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label
                  htmlFor="category"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('services_offered')}
                  <span className="text-danger ml-1">*</span>
                </label>
                <div className="mt-1">
                  <Select
                    defaultValue={[
                      {
                        ...servicesOffered[0],
                        label: translate(servicesOffered[0].label),
                      },
                    ]}
                    isMulti
                    name="services"
                    options={servicesOffered.map((service) => ({
                      ...service,
                      label: translate(service.label),
                    }))}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="method"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('service_delivery_method')}
                  <span className="text-danger ml-1">*</span>
                </label>
                <div className="mt-1">
                  <select
                    id="method"
                    name="method"
                    autoComplete="method"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                  >
                    {serviceDeliveryMethod.map((method) => (
                      <option key={method} value={method}>
                        {translate(method)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label
                  htmlFor="language"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('languages_supported')}
                  <span className="text-danger ml-1">*</span>
                </label>
                <div className="mt-1">
                  <select
                    id="language"
                    name="language"
                    autoComplete="language"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                  >
                    {languagesSupported.map((language) => (
                      <option key={language} value={language}>
                        {translate('language')}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label
                  htmlFor="language"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('website')}
                </label>
                <div className="mt-1">
                  <Input
                    id="firstname"
                    name="firstname"
                    type="text"
                    autoComplete="website"
                  />
                </div>
              </div>
            </Form>
          </div>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
    </>
  )
}
